import React from 'react';

const InvoiceHeader = ({ invoiceNumber, invoiceDate, dueDate, onInvoiceNumberChange, onInvoiceDateChange, onDueDateChange }) => {
  return (
    <div className="flex justify-between items-start mb-10 border-b pb-6">
      <div className="flex items-start">
        {/* DaSigma Software Solutions Sigma Logo */}
        <img src="https://i.imgur.com/DviRcJB.png" alt="Company Logo" crossOrigin="anonymous" className="h-44 w-auto mr-4 rounded-xl" />
        <div>
          <h1 className="text-4xl font-bold text-gray-800">INVOICE</h1>
          <div className="mt-4 text-sm text-gray-600">
            <p>Opelousas, LA 70570</p>
            <p>Phone: (337) 418-0664</p>
            <p>Email: admin@dasigmasoftwaresolutions.com</p>
          </div>
        </div>
      </div>
      <div className="text-right text-sm text-gray-600">
        <div className="mb-2">
          <p className="font-bold">INVOICE #</p>
          <input
            type="text"
            id="invoice-number-input"
            value={invoiceNumber}
            onChange={(e) => onInvoiceNumberChange(e.target.value)}
            className="text-right font-normal text-gray-800 bg-gray-50 rounded-md px-2 py-1 mt-1"
          />
        </div>
        <div className="mb-2">
          <p className="font-bold">Date</p>
          <input
            type="date"
            id="invoice-date-input"
            value={invoiceDate}
            onChange={(e) => onInvoiceDateChange(e.target.value)}
            className="text-right font-normal text-gray-800 bg-gray-50 rounded-md px-2 py-1 mt-1"
          />
        </div>
        <div>
          <p className="font-bold">Due Date</p>
          <input
            type="date"
            id="due-date-input"
            value={dueDate}
            onChange={(e) => onDueDateChange(e.target.value)}
            className="text-right font-normal text-gray-800 bg-gray-50 rounded-md px-2 py-1 mt-1"
          />
        </div>
      </div>
    </div>
  );
};

export default InvoiceHeader;